export const tooltips = {
    value: {
        cpm: 'Estimated Cost per Mile, calculated as (Spend / Impressions) * 1000',
    },
};
